module.exports = __webpack_public_path__ + "static/media/pakistan.21072d16.svg";